import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useInsurerStore = defineStore({
    id: 'insurer',
    state: () => ({
        headerList: ['TPA', 'Check Up Services', 'Vaccinations', 'Telemedicines', 'Emergency Assistance', 'Nursing Services'],
        eggDescList: [
            {
                eggIconObj: { componentName: 'insurer', imgName: 'investment', imgFormat: 'svg', width: '4.6vw' },
                label: 'insurer.econHealthPlans'
            },
            {
                eggIconObj: { componentName: 'insurer', imgName: 'computer', imgFormat: 'svg', width: '4.6vw' },
                label: 'insurer.claimAnaly'
            },
            {
                eggIconObj: { componentName: 'insurer', imgName: 'links', imgFormat: 'svg', width: '4.6vw' },
                label: 'insurer.statApp'
            }
        ],
        photoDescList: [
            {
                id: 'callcentre',
                label: '',
                description: 'insurer.callCentreDesc',
                image: { componentName: 'insurer', imgName: 'callCentre', imgFormat: 'svg' },
            },
        ]
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useInsurerStore, import.meta.hot));
}

export { useInsurerStore };
